/* ═══════════════════════════════════════════════════════════════
   AMSHRMS — Theme Constants for JSX Inline Styles
   
   Usage in any component:
     import T from '../../assets/styles/theme';
     <div style={{ color: T.accent, background: T.bg }}>

   TO CHANGE COLORS: Edit theme.css (CSS variables) for CSS files,
   and edit this file for JSX inline styles. Keep both in sync.
   ═══════════════════════════════════════════════════════════════ */

const T = {
  // ─── 10% ACCENT ───
  accent:       '#2563eb',
  accentHover:  '#1d4ed8',
  accentLight:  '#3b82f6',
  accentSoft:   '#60a5fa',
  accentBg:     '#eff6ff',
  accentBg2:    '#dbeafe',

  // ─── 30% DARK / TEXT ───
  dark:         '#1e3a5f',
  dark2:        '#264b7a',
  dark3:        '#334155',
  text:         '#1f2937',
  textLight:    '#64748b',
  textMuted:    '#94a3b8',

  // ─── 60% SURFACE ───
  bg:           '#f9fafb',
  bgAlt:        '#f3f4f6',
  surface:      '#ffffff',
  border:       '#e5e7eb',
  borderLight:  '#d1d5db',

  // ─── SEMANTIC ───
  success:      '#2563eb',
  successLight: '#3b82f6',
  successBg:    '#eff6ff',
  successBorder:'#bfdbfe',

  danger:       '#ef4444',
  dangerDark:   '#dc2626',
  dangerBg:     '#fef2f2',
  dangerBorder: '#fecaca',

  warning:      '#d97706',
  warningLight: '#f59e0b',
  warningBg:    '#fffbeb',
  warningBorder:'#fde68a',

  info:         '#2563eb',
  infoBg:       '#eff6ff',
  infoBorder:   '#bfdbfe',

  purple:       '#7c3aed',
  purpleLight:  '#8b5cf6',
  purpleBg:     '#faf5ff',

  orange:       '#ea580c',
  teal:         '#2563eb',
};

export default T;
